<template>
  <li class="flex items-center lg:col-span-1">
    <div class="flex-shrink-0">
      <svg :class="'h-8 w-8 ' + color" fill="currentColor" viewBox="0 0 20 20">
        <path
          fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
          clip-rule="evenodd"
        />
      </svg>
    </div>
    <p class="ml-3 font-semibold leading-5 text-black text-sm md:text-base">{{ topic }}</p>
  </li>
</template>
<script lang="js">

export default {
  props: {
    topic: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true,
      default: "text-darkBlue"
    }
  }
}
</script>
